import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/outline';

const SavedPaymentMethodsSelector = ({
  savedPaymentMethods = [],
  selectedSavedMethod,
  useNewCard,
  onSelectedMethodChange,
  onUseNewCardChange,
  disabled = false
}) => {
  const handleMethodChange = (methodId) => {
    if (methodId === 'new-card') {
      onUseNewCardChange(true);
      onSelectedMethodChange(null);
    } else {
      onUseNewCardChange(false);
      const method = savedPaymentMethods.find(m => m.id.toString() === methodId);
      onSelectedMethodChange(method);
    }
  };

  // If no saved methods, don't render anything
  if (!savedPaymentMethods.length) {
    return null;
  }

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Payment Method</h3>

      <div className="space-y-3">
        {/* Saved Payment Methods */}
        {savedPaymentMethods.map((method) => (
          <div
            key={method.id}
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <input
              id={`payment-${method.id}`}
              name="paymentMethod"
              type="radio"
              className="form-radio h-4 w-4 text-brand-teal focus:ring-brand-teal border-gray-300 flex-shrink-0"
              value={method.id}
              checked={!useNewCard && selectedSavedMethod?.id === method.id}
              onChange={() => handleMethodChange(method.id.toString())}
              disabled={disabled}
            />
            <label htmlFor={`payment-${method.id}`} className="ml-3 flex items-center cursor-pointer flex-1">
              <CreditCardIcon className="h-5 w-5 text-gray-400 mr-3 flex-shrink-0" />
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-medium text-gray-900">
                    {method.cardBrand?.toUpperCase() || 'CARD'} •••• {method.last4}
                  </div>
                  {method.isDefault && (
                    <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-brand-teal text-white">
                      Default
                    </span>
                  )}
                </div>
                {method.expirationMonth && method.expirationYear && (
                  <div className="text-sm text-gray-500 mt-1">
                    Expires {method.expirationMonth.toString().padStart(2, '0')}/{method.expirationYear}
                  </div>
                )}
              </div>
            </label>
          </div>
        ))}

        {/* Use New Card Option */}
        <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          <input
            id="payment-new-card"
            name="paymentMethod"
            type="radio"
            className="form-radio h-4 w-4 text-brand-teal focus:ring-brand-teal border-gray-300 flex-shrink-0"
            value="new-card"
            checked={useNewCard}
            onChange={() => handleMethodChange('new-card')}
            disabled={disabled}
          />
          <label htmlFor="payment-new-card" className="ml-3 flex items-center cursor-pointer flex-1">
            <CreditCardIcon className="h-5 w-5 text-gray-400 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-900">Use a new card</div>
              <div className="text-sm text-gray-500 mt-1">Enter new payment information</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default SavedPaymentMethodsSelector; 